import { render, staticRenderFns } from "./WordToolButtonP.vue?vue&type=template&id=b9ddc29e&scoped=true&"
import script from "./WordToolButtonP.vue?vue&type=script&lang=js&"
export * from "./WordToolButtonP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ddc29e",
  null
  
)

export default component.exports